const state = {
  all: [{'id': '01', 'name': 'Ain', 'name_upper': 'AIN', 'slug': 'ain'}, {
    'id': '02',
    'name': 'Aisne',
    'name_upper': 'AISNE',
    'slug': 'aisne'
  }, {'id': '03', 'name': 'Allier', 'name_upper': 'ALLIER', 'slug': 'allier'}, {
    'id': '04',
    'name': 'Alpes-de-Haute-Provence',
    'name_upper': 'ALPES-DE-HAUTE-PROVENCE',
    'slug': 'alpes-de-haute-provence'
  }, {'id': '05', 'name': 'Hautes-Alpes', 'name_upper': 'HAUTES-ALPES', 'slug': 'hautes-alpes'}, {
    'id': '06',
    'name': 'Alpes-Maritimes',
    'name_upper': 'ALPES-MARITIMES',
    'slug': 'alpes-maritimes'
  }, {'id': '07', 'name': 'Ard\u00e8che', 'name_upper': 'ARD\u00c8CHE', 'slug': 'ardeche'}, {
    'id': '08',
    'name': 'Ardennes',
    'name_upper': 'ARDENNES',
    'slug': 'ardennes'
  }, {'id': '09', 'name': 'Ari\u00e8ge', 'name_upper': 'ARI\u00c8GE', 'slug': 'ariege'}, {
    'id': '10',
    'name': 'Aube',
    'name_upper': 'AUBE',
    'slug': 'aube'
  }, {'id': '11', 'name': 'Aude', 'name_upper': 'AUDE', 'slug': 'aude'}, {
    'id': '12',
    'name': 'Aveyron',
    'name_upper': 'AVEYRON',
    'slug': 'aveyron'
  }, {
    'id': '13',
    'name': 'Bouches-du-Rh\u00f4ne',
    'name_upper': 'BOUCHES-DU-RH\u00d4NE',
    'slug': 'bouches-du-rhone'
  }, {'id': '14', 'name': 'Calvados', 'name_upper': 'CALVADOS', 'slug': 'calvados'}, {
    'id': '15',
    'name': 'Cantal',
    'name_upper': 'CANTAL',
    'slug': 'cantal'
  }, {'id': '16', 'name': 'Charente', 'name_upper': 'CHARENTE', 'slug': 'charente'}, {
    'id': '17',
    'name': 'Charente-Maritime',
    'name_upper': 'CHARENTE-MARITIME',
    'slug': 'charente-maritime'
  }, {'id': '18', 'name': 'Cher', 'name_upper': 'CHER', 'slug': 'cher'}, {
    'id': '19',
    'name': 'Corr\u00e8ze',
    'name_upper': 'CORR\u00c8ZE',
    'slug': 'correze'
  }, {'id': '21', 'name': 'C\u00f4te-d\'or', 'name_upper': 'C\u00d4TE-D\'OR', 'slug': 'cote-dor'}, {
    'id': '22',
    'name': 'C\u00f4tes-d\'armor',
    'name_upper': 'C\u00d4TES-D\'ARMOR',
    'slug': 'cotes-darmor'
  }, {'id': '23', 'name': 'Creuse', 'name_upper': 'CREUSE', 'slug': 'creuse'}, {
    'id': '24',
    'name': 'Dordogne',
    'name_upper': 'DORDOGNE',
    'slug': 'dordogne'
  }, {'id': '25', 'name': 'Doubs', 'name_upper': 'DOUBS', 'slug': 'doubs'}, {
    'id': '26',
    'name': 'Dr\u00f4me',
    'name_upper': 'DR\u00d4ME',
    'slug': 'drome'
  }, {'id': '27', 'name': 'Eure', 'name_upper': 'EURE', 'slug': 'eure'}, {
    'id': '28',
    'name': 'Eure-et-Loir',
    'name_upper': 'EURE-ET-LOIR',
    'slug': 'eure-et-loir'
  }, {'id': '29', 'name': 'Finist\u00e8re', 'name_upper': 'FINIST\u00c8RE', 'slug': 'finistere'}, {
    'id': '30',
    'name': 'Gard',
    'name_upper': 'GARD',
    'slug': 'gard'
  }, {'id': '31', 'name': 'Haute-Garonne', 'name_upper': 'HAUTE-GARONNE', 'slug': 'haute-garonne'}, {
    'id': '32',
    'name': 'Gers',
    'name_upper': 'GERS',
    'slug': 'gers'
  }, {'id': '33', 'name': 'Gironde', 'name_upper': 'GIRONDE', 'slug': 'gironde'}, {
    'id': '34',
    'name': 'H\u00e9rault',
    'name_upper': 'H\u00c9RAULT',
    'slug': 'herault'
  }, {'id': '35', 'name': 'Ile-et-Vilaine', 'name_upper': 'ILE-ET-VILAINE', 'slug': 'ile-et-vilaine'}, {
    'id': '36',
    'name': 'Indre',
    'name_upper': 'INDRE',
    'slug': 'indre'
  }, {'id': '37', 'name': 'Indre-et-Loire', 'name_upper': 'INDRE-ET-LOIRE', 'slug': 'indre-et-loire'}, {
    'id': '38',
    'name': 'Is\u00e8re',
    'name_upper': 'IS\u00c8RE',
    'slug': 'isere'
  }, {'id': '39', 'name': 'Jura', 'name_upper': 'JURA', 'slug': 'jura'}, {
    'id': '40',
    'name': 'Landes',
    'name_upper': 'LANDES',
    'slug': 'landes'
  }, {'id': '41', 'name': 'Loir-et-Cher', 'name_upper': 'LOIR-ET-CHER', 'slug': 'loir-et-cher'}, {
    'id': '42',
    'name': 'Loire',
    'name_upper': 'LOIRE',
    'slug': 'loire'
  }, {'id': '43', 'name': 'Haute-Loire', 'name_upper': 'HAUTE-LOIRE', 'slug': 'haute-loire'}, {
    'id': '44',
    'name': 'Loire-Atlantique',
    'name_upper': 'LOIRE-ATLANTIQUE',
    'slug': 'loire-atlantique'
  }, {'id': '45', 'name': 'Loiret', 'name_upper': 'LOIRET', 'slug': 'loiret'}, {
    'id': '46',
    'name': 'Lot',
    'name_upper': 'LOT',
    'slug': 'lot'
  }, {'id': '47', 'name': 'Lot-et-Garonne', 'name_upper': 'LOT-ET-GARONNE', 'slug': 'lot-et-garonne'}, {
    'id': '48',
    'name': 'Loz\u00e8re',
    'name_upper': 'LOZ\u00c8RE',
    'slug': 'lozere'
  }, {'id': '49', 'name': 'Maine-et-Loire', 'name_upper': 'MAINE-ET-LOIRE', 'slug': 'maine-et-loire'}, {
    'id': '50',
    'name': 'Manche',
    'name_upper': 'MANCHE',
    'slug': 'manche'
  }, {'id': '51', 'name': 'Marne', 'name_upper': 'MARNE', 'slug': 'marne'}, {
    'id': '52',
    'name': 'Haute-Marne',
    'name_upper': 'HAUTE-MARNE',
    'slug': 'haute-marne'
  }, {'id': '53', 'name': 'Mayenne', 'name_upper': 'MAYENNE', 'slug': 'mayenne'}, {
    'id': '54',
    'name': 'Meurthe-et-Moselle',
    'name_upper': 'MEURTHE-ET-MOSELLE',
    'slug': 'meurthe-et-moselle'
  }, {'id': '55', 'name': 'Meuse', 'name_upper': 'MEUSE', 'slug': 'meuse'}, {
    'id': '56',
    'name': 'Morbihan',
    'name_upper': 'MORBIHAN',
    'slug': 'morbihan'
  }, {'id': '57', 'name': 'Moselle', 'name_upper': 'MOSELLE', 'slug': 'moselle'}, {
    'id': '58',
    'name': 'Ni\u00e8vre',
    'name_upper': 'NI\u00c8VRE',
    'slug': 'nievre'
  }, {'id': '59', 'name': 'Nord', 'name_upper': 'NORD', 'slug': 'nord'}, {
    'id': '60',
    'name': 'Oise',
    'name_upper': 'OISE',
    'slug': 'oise'
  }, {'id': '61', 'name': 'Orne', 'name_upper': 'ORNE', 'slug': 'orne'}, {
    'id': '62',
    'name': 'Pas-de-Calais',
    'name_upper': 'PAS-DE-CALAIS',
    'slug': 'pas-de-calais'
  }, {'id': '63', 'name': 'Puy-de-D\u00f4me', 'name_upper': 'PUY-DE-D\u00d4ME', 'slug': 'puy-de-dome'}, {
    'id': '64',
    'name': 'Pyr\u00e9n\u00e9es-Atlantiques',
    'name_upper': 'PYR\u00c9N\u00c9ES-ATLANTIQUES',
    'slug': 'pyrenees-atlantiques'
  }, {
    'id': '65',
    'name': 'Hautes-Pyr\u00e9n\u00e9es',
    'name_upper': 'HAUTES-PYR\u00c9N\u00c9ES',
    'slug': 'hautes-pyrenees'
  }, {
    'id': '66',
    'name': 'Pyr\u00e9n\u00e9es-Orientales',
    'name_upper': 'PYR\u00c9N\u00c9ES-ORIENTALES',
    'slug': 'pyrenees-orientales'
  }, {'id': '67', 'name': 'Bas-Rhin', 'name_upper': 'BAS-RHIN', 'slug': 'bas-rhin'}, {
    'id': '68',
    'name': 'Haut-Rhin',
    'name_upper': 'HAUT-RHIN',
    'slug': 'haut-rhin'
  }, {'id': '69', 'name': 'Rh\u00f4ne', 'name_upper': 'RH\u00d4NE', 'slug': 'rhone'}, {
    'id': '70',
    'name': 'Haute-Sa\u00f4ne',
    'name_upper': 'HAUTE-SA\u00d4NE',
    'slug': 'haute-saone'
  }, {
    'id': '71',
    'name': 'Sa\u00f4ne-et-Loire',
    'name_upper': 'SA\u00d4NE-ET-LOIRE',
    'slug': 'saone-et-loire'
  }, {'id': '72', 'name': 'Sarthe', 'name_upper': 'SARTHE', 'slug': 'sarthe'}, {
    'id': '73',
    'name': 'Savoie',
    'name_upper': 'SAVOIE',
    'slug': 'savoie'
  }, {'id': '74', 'name': 'Haute-Savoie', 'name_upper': 'HAUTE-SAVOIE', 'slug': 'haute-savoie'}, {
    'id': '75',
    'name': 'Paris',
    'name_upper': 'PARIS',
    'slug': 'paris'
  }, {'id': '76', 'name': 'Seine-Maritime', 'name_upper': 'SEINE-MARITIME', 'slug': 'seine-maritime'}, {
    'id': '77',
    'name': 'Seine-et-Marne',
    'name_upper': 'SEINE-ET-MARNE',
    'slug': 'seine-et-marne'
  }, {'id': '78', 'name': 'Yvelines', 'name_upper': 'YVELINES', 'slug': 'yvelines'}, {
    'id': '79',
    'name': 'Deux-S\u00e8vres',
    'name_upper': 'DEUX-S\u00c8VRES',
    'slug': 'deux-sevres'
  }, {'id': '80', 'name': 'Somme', 'name_upper': 'SOMME', 'slug': 'somme'}, {
    'id': '81',
    'name': 'Tarn',
    'name_upper': 'TARN',
    'slug': 'tarn'
  }, {'id': '82', 'name': 'Tarn-et-Garonne', 'name_upper': 'TARN-ET-GARONNE', 'slug': 'tarn-et-garonne'}, {
    'id': '83',
    'name': 'Var',
    'name_upper': 'VAR',
    'slug': 'var'
  }, {'id': '84', 'name': 'Vaucluse', 'name_upper': 'VAUCLUSE', 'slug': 'vaucluse'}, {
    'id': '85',
    'name': 'Vend\u00e9e',
    'name_upper': 'VEND\u00c9E',
    'slug': 'vendee'
  }, {'id': '86', 'name': 'Vienne', 'name_upper': 'VIENNE', 'slug': 'vienne'}, {
    'id': '87',
    'name': 'Haute-Vienne',
    'name_upper': 'HAUTE-VIENNE',
    'slug': 'haute-vienne'
  }, {'id': '88', 'name': 'Vosges', 'name_upper': 'VOSGES', 'slug': 'vosges'}, {
    'id': '89',
    'name': 'Yonne',
    'name_upper': 'YONNE',
    'slug': 'yonne'
  }, {
    'id': '90',
    'name': 'Territoire de Belfort',
    'name_upper': 'TERRITOIRE DE BELFORT',
    'slug': 'territoire-de-belfort'
  }, {'id': '91', 'name': 'Essonne', 'name_upper': 'ESSONNE', 'slug': 'essonne'}, {
    'id': '92',
    'name': 'Hauts-de-Seine',
    'name_upper': 'HAUTS-DE-SEINE',
    'slug': 'hauts-de-seine'
  }, {
    'id': '93',
    'name': 'Seine-Saint-Denis',
    'name_upper': 'SEINE-SAINT-DENIS',
    'slug': 'seine-saint-denis'
  }, {'id': '94', 'name': 'Val-de-Marne', 'name_upper': 'VAL-DE-MARNE', 'slug': 'val-de-marne'}, {
    'id': '95',
    'name': 'Val-d\'oise',
    'name_upper': 'VAL-D\'OISE',
    'slug': 'val-doise'
  }]
}

const getters = {
  all: state => state.all
}

export default {
  namespaced: true,
  state,
  getters
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/departments.js